function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3335 13.3333C13.6871 13.3333 14.0263 13.1929 14.2763 12.9428C14.5264 12.6928 14.6668 12.3536 14.6668 12V5.33333C14.6668 4.97971 14.5264 4.64057 14.2763 4.39052C14.0263 4.14048 13.6871 4 13.3335 4H8.06683C7.84384 4.00219 7.62386 3.94841 7.42703 3.84359C7.2302 3.73877 7.0628 3.58625 6.94016 3.4L6.40016 2.6C6.27876 2.41565 6.11348 2.26432 5.91916 2.1596C5.72485 2.05488 5.50757 2.00004 5.28683 2H2.66683C2.31321 2 1.97407 2.14048 1.72402 2.39052C1.47397 2.64057 1.3335 2.97971 1.3335 3.33333V12C1.3335 12.3536 1.47397 12.6928 1.72402 12.9428C1.97407 13.1929 2.31321 13.3333 2.66683 13.3333H13.3335Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.237b117e.svg";
export { ForwardRef as ReactComponent };